<template>
  <card class="member-info">
    <div class="id-card-pic">
      <el-image
        class="el-image"
        style="margin-right: 10px"
        :src="memberInfo ? memberInfo.idCardImage1 : ''"
        :preview-src-list="memberInfo ? [memberInfo.idCardImage1] : []"
      />
      <el-image
        class="el-image"
        style=""
        :src="memberInfo ? memberInfo.idCardImage2 : ''"
        :preview-src-list="memberInfo ? [memberInfo.idCardImage2] : []"
      />
    </div>
    <div class="person-info">
      <div>
        <span class="name fw700">{{ memberInfo ? memberInfo.idName : '' }}</span>
        <el-tag>年龄：{{ memberInfo ? memberInfo.age : '' }}</el-tag>
        <el-tag>性别：{{ memberInfo ? memberInfo.genderName : '' }}</el-tag>
      </div>
      <div>
        <span>
          <span class="label">身份证号：</span>
          <span class="fw700">{{ memberInfo ? memberInfo.idCard : '' }}</span>
        </span>
      </div>
      <div>
        <span>
          <span class="label">户籍所在地：</span>
          <span class="fw700">{{ memberInfo ? memberInfo.idAddress : '' }}</span>
        </span>
      </div>
    </div>
  </card>
</template>

<script>
export default {
  name: "JhMemberInfo",

  props: {
    memberInfo: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.member-info /deep/ {
  display: flex;
  align-items: flex-start;
  width: 100%;
  border: 1px solid #c5c5c5;
  border-radius: 15px;
  padding: 15px 20px;

  .fw700 {
    font-weight: 700;
  }

  .label {
    color: #666666;
    font-size: 14px;
  }

  .id-card-pic {
    margin-right: 2%;

    .el-image {
      height: 100px;
      width: 100px;
    }
  }

  .person-info {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    line-height: 35px;

    .mr50 {
      margin-right: 50px;
    }

    .el-tag {
      height: 25px;
      border-radius: 15px;
      margin-right: 10px;
      line-height: 25px;
      color: #000000;
      background-color: #ffffff;
    }

    .name {
      color: #222222;
      font-size: 18px;
      font-family: 微软雅黑;
      margin-right: 2%;
    }
  }
}
</style>
